<template>
  <nav class="t-navigation t-navigation--light" aria-label="網站導覽列">
    <slot name="menu"></slot>
    <!-- 原本主頁 -->
    <h1 class="t-navigation__logo" v-if="!isFestivalYear">
      <!-- 廟宇 logo -->
      <a href="/" class="t-navigation__logo__link" title="[前往]首頁">
        <img
          :src="logoPng"
          alt="臺南宗教藝術的首頁"
          class="t-navigation__logo__image t-navigation__logo__image--temple"
        />
      </a>
    </h1>
    <!-- 香科年 logo -->
    <h1 class="t-navigation__logo" v-else-if="isFestivalYear">
      <router-link :to="{ name: 'festivalYear' }" title="[前往]香科年活動首頁">
        <img
          class="t-navigation__logo__image t-navigation__logo__image--festival"
          alt="香科年活動首頁"
          :src="require(`@/assets/images/logo_festival.svg`)"
        />
      </router-link>
    </h1>
    <slot name="login"></slot>
  </nav>
</template>

<script>
import logoPng from '@/assets/images/logo_new@2x.png';

export default {
  name: 'TheNavbar',
  props: {
    isHomePath: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    logoPng() {
      return logoPng;
    },
    isFestivalYear() {
      return this.$route.meta.isRenderingFestivalTheme;
    },
  },
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped>
$navigationHeight: (
  'mobile': 48px,
  'tablet': 65px,
);

.t-navigation {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-content: center;
  height: map-get($navigationHeight, mobile);
  line-height: map-get($navigationHeight, mobile);
  margin-top: 1px;
  width: 95%;
  margin: auto;
  z-index: getLayerIndex(navbar);

  @include for-desktop {
    height: map-get($navigationHeight, tablet);
    line-height: map-get($navigationHeight, tablet);
  }

  &__logo {
    position: absolute;
    left: 55px;
    right: 55px;
    top: 18px;
    text-align: center;
    margin: 0;
    font-size: 1.5rem;
    line-height: 1.875;
    z-index: getLayerIndex(logo);
    @extend %no-select;

    &__link {
      display: inline-block;
    }

    &__image {
      object-fit: contain;
      vertical-align: middle;

      @include for-desktop {
        display: none;
      }

      &--temple {
        width: 184px;
        height: 41px;
        top: 17px;
      }

      &--festival {
        width: 182px;
        height: 39px;
        top: 15px;
      }
    }
  }

  &--light {
    justify-content: center;
    align-items: center;

    @include for-desktop {
      line-height: 45px;
      top: 24px;
    }

    .t-navigation__logo__image {
      position: relative;
      margin: 0;
    }

    /deep/ .t-navigation__menu {
      position: absolute;
      left: 0;
      top: 37px;

      &__popup {
        top: 57px;
      }

      .t-navigation__menu__go-back {
        @include for-desktop {
          position: fixed;
          margin: 0;
          top: 42px;
          right: 5px;
          width: 180px;
        }

        a {
          background: none;

          &::after {
            @include for-desktop {
              background: none;
            }
          }
        }

        img {
          @include for-desktop {
            height: 20px;
            max-width: 100%;
          }
        }
      }

      &__close-layer {
        top: -95px;
      }

      &__links {
        background: $color-light-bg;
        font-family: $text-font-family;
        letter-spacing: 1px;

        @include for-desktop {
          background: transparent;
          justify-content: flex-start;
          border: 0;
          font-size: 1.4rem;
          top: -83px;
          height: 65px;
        }
      }

      &__item {
        padding-left: 16px;

        @include for-desktop {
          padding-left: 0;
          border: 0;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex: 1 0 auto;
          margin-right: 30px;

          &:first-child {
            padding-left: 20px;
          }
        }

        @include for-desktop {
          margin-right: 35px;
        }

        &--main {
          a {
            position: relative;

            span {
              position: relative;
              &::before,
              &::after {
                content: '';
                position: absolute;
                width: 9px;
                height: 2px;
                background: $color-light-link;
                right: -15px;
              }

              &::before {
                transform: rotate(45deg);
                top: 7px;

                @include for-desktop {
                  top: 13px;
                }
              }

              &::after {
                transform: rotate(-45deg);
                bottom: 8px;

                @include for-desktop {
                  bottom: 11px;
                }
              }
            }
          }
        }

        a {
          position: relative;
          background: url('../assets/images/menu/light-direction-right.svg')
            right 16px top 55% no-repeat;
          color: $color-light-link;
          display: block;
          width: 100%;

          @include for-desktop {
            background: none;
            &::after {
              position: absolute;
              content: '';
              background: url('../assets/images/menu/light-direction-right.svg')
                right 16px top 55% no-repeat;
              height: 30px;
              width: 32px;
              top: 8px;
              margin-left: 8px;
            }
          }

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }

    /deep/ .t-navigation__menu__item + .t-navigation__menu__item {
      @include for-desktop {
        &::before {
          content: '';
          background: none;
        }
      }
    }
  }
}
</style>
